module.exports = __webpack_public_path__ + "img/icon-businessgepaeck.b89b9d19.svg";